import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskCollectIDLayout.styles';
// import { Paper } from '@material-ui/core';
import {
  KioskSideSlides,
  KioskFooter,
  KioskHeader,
  KioskCollectIDMain,
  KioskIdelScreen
} from '..';

export class KioskCollectIDLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: 'Step 6 :',
    pageTitle: 'Let us know who’s picking up',
    customTop: '6%',
    customHeight: '120px'
  };

  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width === 1080) {
      customFooterBottom = '0%';
    } else if (window.screen.width === 1440 || window.screen.width === 1920) {
      customFooterBottom = '0%';
    } else {
      customFooterBottom = '0%';
    }
    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskSideSlides
          stepTitle={this.state.stepTitle}
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={this.state.customHeight}
        />

        <KioskCollectIDMain />
        <KioskFooter customFooterBottom={customFooterBottom} />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskCollectIDLayout);
